export const tourInfo = {
  label: "Tour Information",
  columns: [
    [
      {
        type: "text",
        name: "students",
        label: "Number of Students",
        description: "The maximum group size is 30; one classroom per tour",
        required: true,
      },
      {
        type: "text",
        name: "teachers",
        label: "Number of Teachers",
        required: true,
      },
      {
        type: "text",
        name: "grade",
        label: "Grade Level(s)",
        required: true,
      },
      {
        type: "date",
        name: "preferred_date",
        label: "Preferred Tour Date",
        description:
          "Tours are offered 9am-12pm (The Norton is taking tour requests through December 2023)",
        placeholder: "MM/DD/YYYY",
        required: true,
      },
      {
        type: "date",
        name: "alternative_date",
        label: "Alternative Tour Date",
        placeholder: "MM/DD/YYYY",
        required: true,
      },
      {
        type: "radio",
        name: "tour_time",
        label: "Tour Times (45-minute length)",
        options: [
          { label: "9:00 AM", value: "9:00 AM" },
          { label: "10:00 AM", value: "10:00 AM" },
          { label: "11:00 AM", value: "11:00 AM" },
          { label: "Other", value: "Other" },
        ],
        required: true,
        other: { name: "tour_time_other", label: "Other Tour Time" },
      },
    ],
    [
      {
        type: "radio",
        name: "theme",
        label: "Available Tours Themes",
        description:
          "To learn more about our tours, please go to <a href='https://www.norton.org/programs/studentsandteachers/k-12home' target='_blank'>School Tour Themes</a>",
        options: [
          {
            label: "Learning to Look (K-12) VA, LA, SS, SC, MA",
            value: "Learning to Look",
          },
          {
            label: "Storytelling in Art (K-12) VA, LA, SS, SC, MA",
            value: "Storytelling in Art",
          },
          { label: "STEAM Tour (K-12) VA, LA, SS, SC, MA", value: "STEAM" },
          {
            label:
              "Special Exhibition: <i>Strike Fast, Dance Lightly</i><br>OCTOBER 28, 2024 – MARCH 4, 2025",
            value: "Special Exhibition, Strike Fast, Dance Lightly",
          },
          {
            label:
              "Special Exhibition: <i>Sorolla and the Sea</i><br>DECEMBER 2, 2024 – APRIL 11, 2025",
            value: "Special Exhibition, Sorolla and the Sea",
          },
        ],
        required: true,
      },
      {
        type: "radio",
        name: "video",
        label: "Preferred Video Platform",
        options: [
          { label: "Google Meet", value: "google" },
          { label: "Zoom", value: "zoom" },
          { label: "Microsoft Teams", value: "microsoft" },
          { label: "Other", value: "Other" },
        ],
        required: true,
        other: { name: "video_other", label: "Other Video Platform" },
      },
      {
        type: "text",
        name: "test_call",
        label: "Best Time for a Technology Test Call",
        description:
          "During this 10-15 minutes video call we test audio, camera, and communication prior to your tour. We contact you 1-2 days prior to your session via your preferred platform.",
        required: true,
      },
      {
        type: "text",
        name: "goals",
        label: "Goals of Your Tour",
        description:
          "Please specify what subject/elective your group is along with any curricular connections or what students are learning in the classroom around the time of your tour",
        required: true,
      },
    ],
  ],
};

export const additionalInfo = {
  label: "Additional Information",
  columns: [
    [
      {
        type: "checkbox",
        name: "school_type[]",
        label: "School Type",
        description: "Please select ALL that apply.",
        options: [
          { label: "Public", value: "Public" },
          { label: "Private", value: "Private" },
          { label: "Charter", value: "Charter" },
          { label: "Magnet", value: "Magnet" },
          { label: "Title I", value: "Title I" },
          {
            label:
              "Homeschool (<a href='https://www.norton.org/event-series/homeschool-tours' target=_blank>Learn More</a>)",
            value: "Homeschool",
          },
          { label: "Other", value: "Other" },
        ],
        required: true,
        other: { name: "school_type_other", label: "Other School Type" },
      },
      {
        type: "checkbox",
        name: "classroom_type[]",
        label: "Classroom Type",
        description: "Please select ALL that apply.",
        options: [
          { label: "General Education", value: "General Education" },
          { label: "ELL/ESOL", value: "ELL/ESOL" },
          {
            label: "Special Education/ESE/Gifted",
            value: "Special Education/ESE/Gifted",
          },
          { label: "AP", value: "AP" },
          { label: "ASD (autism spectrum disorder)", value: "ASD" },
          { label: "Other", value: "Other" },
        ],
        required: true,
        other: { name: "classroom_type_other", label: "Other Classroom Type" },
      },
    ],
    [
      {
        type: "checkbox",
        name: "special_needs[]",
        label:
          "Special accommodations or requests for students with disabilities",
        description:
          "The Norton Museum of Art provides special accommodations for students with disabilities and trained staff to work with your individualized student needs",
        options: [
          { label: "ASL Interpretation", value: "ASL Interpretation" },
          {
            label: "Special Education/ESE/Gifted",
            value: "Special Education/ESE/Gifted Special Needs",
          },
          {
            label: "ASD (autism spectrum disorder)",
            value: "ASD Special Needs",
          },
          {
            label: "No special accommodations or requests for my group ",
            value: "None",
          },
          { label: "Other", value: "Other" },
        ],
        required: true,
        other: {
          name: "special_needs_other",
          label: "Please specify what accommodations are needed for your group",
          showLabel: true,
          required: true,
        },
      },
      {
        type: "radio",
        name: "spanish",
        label: "Spanish tour available. Subject to staff availability.",
        options: [
          { label: "Yes, I'm interested", value: "1" },
          { label: "No, thanks", value: "0" },
        ],
        required: true,
      },
      {
        type: "radio",
        name: "educational_materials",
        label: "Educational Materials",
        description:
          "Educational materials to support virtual tours can be provided by Norton staff with advanced notice.",
        options: [
          { label: "Yes, I'm interested", value: "1" },
          { label: "No, thanks", value: "0" },
        ],
        required: true,
      },
    ],
  ],
};
